import i18n from "i18next";
import { createContext, type ReactNode, use, useState } from "react";

interface LanguageContextType {
	currentLanguage: string;
	changeLanguage: (lang: string) => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(
	undefined,
);

export function LanguageProvider({ children }: { children: ReactNode }) {
	const [currentLanguage, setCurrentLanguage] = useState(
		() =>
			(typeof window !== "undefined" && sessionStorage.getItem("language")) ||
			"en",
	);

	const changeLanguage = (lang: string) => {
		window.fw?.("setLanguage", lang);
		i18n.changeLanguage(lang);
		setCurrentLanguage(lang);
		sessionStorage.setItem("language", lang);
	};

	return (
		<LanguageContext value={{ currentLanguage, changeLanguage }}>
			{children}
		</LanguageContext>
	);
}

export const useLanguage = () => {
	const context = use(LanguageContext);
	if (context === undefined) {
		throw new Error("useLanguage must be used within a LanguageProvider");
	}

	return context;
};
